import React, {createContext} from 'react';

const AllTripsContext = createContext();

export default AllTripsContext;